<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Persistent action: its hitbox alone sits above the native navigation. -->
<button mat-icon-button class="main-navigation-toggle print:hidden"
        (click)="toggleNavigation('mainNavigation')"
        aria-controls="main-sidebar"
        [attr.aria-expanded]="navigationOpened"
        [attr.aria-label]="navigationControlLabel"
        [matTooltip]="navigationControlLabel">
    <mat-icon [svgIcon]="'heroicons_outline:' + navigationControlIcon"></mat-icon>
</button>

<!-- Navigation -->
<fuse-vertical-navigation
    id="main-sidebar"
    class="main-sidebar dark bg-gray-900 print:hidden"
    [appearance]="!isScreenSmall && desktopNavigation === 'icons' ? 'dense' : 'default'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="navigationOpened"
    (openedChanged)="onNavigationOpened($event)">

    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>

        <!-- Top bar -->
        <div class="main-sidebar-topbar flex items-center w-full px-4 py-3 border-b border-white/5">
            <!-- Logo -->
            <div class="main-sidebar-logo flex items-center gap-2">
                <img class="w-9" src="assets/images/logo_sise_blanco.png" alt="SISE">
            </div>

            <!-- Actions -->
            <div *ngIf="navigationOpened" class="main-sidebar-actions flex items-center ml-auto gap-0">
                <notifications
                    [notifications]="isProvider ? alertNotifications : messagesNotifications"
                    [evidenceNotifications]="isProvider ? null : alertNotifications"
                    [unreadCount]="isProvider ? unreadAlertCount : unreadMessageCount + unreadAlertCount">
                </notifications>

                <user [showAvatar]="false" [showHelp]="true"
                      actionIcon="heroicons_outline:dots-vertical" actionLabel="Más opciones"></user>
            </div>
        </div>

        <!-- Profile block -->
        <div class="main-sidebar-profile flex flex-col items-center w-full px-4 py-4">

            <!-- Avatar / Logo -->
            <div
                class="relative w-full max-w-[180px] h-20 rounded-lg overflow-hidden
         bg-white/5 border border-white/10
         flex items-center justify-center">

                <!-- Logo de hotel / entidad (rectangular) -->
                <img
                    *ngIf="hotel?.logo"
                    class="max-w-full max-h-full object-contain p-2"
                    [src]="hotel.logo"
                    alt="Logo entidad"/>

                <!-- Avatar de usuario (fallback) -->
                <img
                    *ngIf="!hotel?.logo && user?.avatar"
                    class="w-16 h-16 rounded-full object-cover"
                    [src]="user.avatar"
                    alt="Avatar usuario"/>

                <!-- Ícono por defecto -->
                <mat-icon
                    *ngIf="!hotel?.logo && !user?.avatar"
                    class="icon-size-24 text-white/70"
                    [svgIcon]="'heroicons_solid:user-circle'">
                </mat-icon>
            </div>

            <!-- Identity -->
            <div class="flex flex-col items-center w-full mt-4">

                <!-- Entidad / Proveedor -->
                <div
                    *ngIf="hotel && (user.rol === 1 || user.rol === 2)"
                    class="w-full text-center font-semibold text-white/90">
                    {{ hotel.hotelName }}
                </div>
                <div
                    *ngIf="hotel && (user.rol === 1 || user.rol === 2)"
                    class="w-full text-center text-xs text-white/60 mt-0.5">
                    RFC: {{ hotel.rfc }}
                </div>

                <div
                    *ngIf="provider && (user.rol === 3)"
                    class="w-full text-center font-semibold text-white/90">
                    {{ provider.businessName }}
                </div>
                <div
                    *ngIf="provider && (user.rol === 3)"
                    class="w-full text-center text-xs text-white/60 mt-0.5">
                    RFC: {{ provider.rfc }}
                </div>

                <!-- Usuario -->
                <ng-container *ngIf="isScreenSmall || desktopNavigation !== 'icons'">
                <div class="w-full text-center font-medium text-white/90 mt-3">
                    {{ user.name }}
                </div>
                <div class="w-full text-center text-md text-white/60 mt-0.5">
                    {{ user.email }}
                </div>
                <div class="w-full flex justify-center mt-1">
 <span
     class="inline-flex items-center px-2.5 py-0.5 text-xs rounded-full border
         text-white/70 border-white/20 bg-white/5">
  {{ user.canEdit ? 'Permisos de edición' : 'Solo lectura' }}
</span>

                </div>
                </ng-container>
            </div>
        </div>

    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter class="mt-2">
        <div class="main-sidebar-brand flex flex-col items-center justify-center gap-2 px-4 pb-4 opacity-60">
            <img class="max-w-28" src="assets/images/logo/taxsat_w.png" alt="TAXSAT">
            <small class="text-xs">{{ versionSISE }}</small>
        </div>
    </ng-container>

</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="main-layout-wrapper flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="main-layout-header relative flex flex-0 items-center w-full h-16 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">

        <app-page-header-context></app-page-header-context>

        <div class="main-header-controls flex flex-shrink-0 items-center pl-2 ml-auto gap-2">
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    <span class="font-medium text-secondary">
      SISE &copy; {{ currentYear }} · {{ versionSISE }}
    </span>
    </div>

</div>
